import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificacaoService } from './notificacao.service';

@Injectable({
  providedIn: 'root'
})
export class CarregandoService {
  constructor(
    private spinnerService: NgxSpinnerService,
    private notificacaoService: NotificacaoService
  ) {}

  operacoes: string[] = [];

  mostra(operacao: string) {
    this.operacoes.push(operacao);
    this.spinnerService.show('principal').then();
  }

  limpaProgresso() {
    this.notificacaoService.atualizacaoProgresso.next({ textoStatus: '' });
  }

  mostraProgresso() {
    this.spinnerService.show('progresso').then();
  }

  escondeProgresso() {
    this.spinnerService.hide('progresso').then();
  }

  esconde(operacao: string) {
    const index = this.operacoes.indexOf(operacao);
    if (index < 0) {
      return;
    }

    this.operacoes.splice(index, 1);

    if (this.operacoes.length > 0) {
      return;
    }

    this.spinnerService.hide('principal').then(() => {
      if (this.operacoes.length > 0) {
        this.spinnerService.show('principal').then();
      }
    });
  }

  zera() {
    this.operacoes = [];
    this.spinnerService.hide('principal').then(() => {
      if (this.operacoes.length > 0) {
        this.spinnerService.show('principal').then();
      }
    });
    this.spinnerService.hide('progresso').then();
  }

  mostrarSpinner(nome: string) {
    this.spinnerService.show(nome).then();
  }

  esconderSpinner(nome: string) {
    this.spinnerService.hide(nome).then();
  }

  estaVazio() {
    return this.operacoes.length === 0;
  }
}
